import React, { useState, useEffect } from "react";
import { Dialog, IconButton, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import "./TasksBoardModal.scss";
import Icon from "components/Icon/Icon";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const TasksBoardModal = ({ open, setOpen, onClose }: any) => {
  const [refreshOnClose, setRefreshOnClose] = useState(false);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => {
        setOpen(false);
        onClose({
          refresh: refreshOnClose,
        });
      }}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#f2f2f4",
        },
      }}
      className="tasks-board-modal-container"
    >
      <div className="modal-header">
        <div className="modal-title">
          <h2>{"Tablero de tareas"}</h2>
        </div>
        <div className="modal-end-btns">
          <IconButton
            color="inherit"
            onClick={() => {
              setOpen(false);
              onClose({
                refresh: refreshOnClose,
              });
            }}
            aria-label="close"
          >
            <Icon name="close" />
          </IconButton>
        </div>
      </div>
      <div className="modal-body"></div>
    </Dialog>
  );
};

export { TasksBoardModal };
